import {
  Grid,
  Box,
  TextField,
  Button,
  Switch,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { useState } from "react";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { useToast } from "../../components/shared/Toast";

import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import InsertPhotoOutlinedIcon from "@material-ui/icons/InsertPhotoOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const PRIORITY_OPTIONS = [1, 2, 3, 4, 5, 6];

export const AddTeam = () => {
  const classes = useAdminStyles();
  const navigate = useNavigate();
  const toast = useToast();

  const [name, setName] = useState("");
  const [skills, setSkills] = useState("");
  const [disgn, setDisgn] = useState("");
  const [desc, setDesc] = useState("");
  const [role, setRole] = useState("");
  const [empPic, setEmpPic] = useState({ raw: "", preview: "" });
  const [status, setStatus] = useState(true);
  const [priority, setPriority] = useState("");
  const [err, setErr] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const handleImageChange = (e) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const file = e.target.files[0];
    const allowed = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    if (!allowed.includes(file.type)) {
      toast.error("Please select only JPEG, JPG, PNG or WebP images.");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image must be smaller than 5 MB.");
      return;
    }
    setEmpPic({
      preview: URL.createObjectURL(file),
      raw: file,
    });
  };

  const onSubmit = () => {
    setErr(0);
    if (!name.trim()) {
      setErr(1);
      toast.error("Please enter the member's name.");
      return;
    }
    if (!disgn.trim()) {
      setErr(2);
      toast.error("Please enter the designation.");
      return;
    }
    if (!skills.trim()) {
      setErr(3);
      toast.error("Please enter the skills.");
      return;
    }
    if (!desc.trim()) {
      setErr(4);
      toast.error("Please enter a short description.");
      return;
    }
    if (!role) {
      setErr(5);
      toast.error("Please select a role.");
      return;
    }
    if (!priority) {
      setErr(6);
      toast.error("Please select a priority.");
      return;
    }
    if (!empPic.raw) {
      setErr(7);
      toast.error("Please select a profile image.");
      return;
    }

    setSubmitting(true);
    const formData = new FormData();
    formData.append("image", empPic.raw);
    formData.append("name", name.trim());
    formData.append("skills", skills.trim());
    formData.append("priority", priority);
    formData.append("description", desc.trim());
    formData.append("desgination", disgn.trim());
    formData.append("role", role);
    formData.append("status", status ? "1" : "0");

    Axios.post("/api/add_team", formData, {
      headers: { headKey: headKey },
    })
      .then((res) => {
        setSubmitting(false);
        if (res.data.status) {
          toast.success(res.data.msg || "Member added");
          navigate("/dash/team");
        } else {
          toast.error(res.data.msg || "Something went wrong. Try again.");
        }
      })
      .catch(() => {
        setSubmitting(false);
        toast.error("Network error. Please try again.");
      });
  };

  return (
    <div>
      <Helmet>
        <title>Add Team - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Team"
        title="Add team member"
        subtitle="Add a leadership or developer profile to the public site."
        backTo="/dash/team"
      />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Name"
            variant="outlined"
            error={err === 1}
            value={name}
            size="small"
            onChange={(e) => setName(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Designation"
            variant="outlined"
            error={err === 2}
            value={disgn}
            size="small"
            onChange={(e) => setDisgn(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Skills"
            variant="outlined"
            error={err === 3}
            value={skills}
            size="small"
            onChange={(e) => setSkills(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            placeholder="React, Node.js, AI..."
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            select
            label="Role"
            variant="outlined"
            error={err === 5}
            value={role}
            size="small"
            onChange={(e) => setRole(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          >
            <MenuItem value="">Select role...</MenuItem>
            <MenuItem value="1">Key People</MenuItem>
            <MenuItem value="2">Developer</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            label="Priority"
            variant="outlined"
            error={err === 6}
            value={priority}
            size="small"
            onChange={(e) => setPriority(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          >
            <MenuItem value="">Select...</MenuItem>
            {PRIORITY_OPTIONS.map((n) => (
              <MenuItem key={n} value={String(n)}>
                {n}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box className={classes.statusRow}>
            <Switch
              checked={status}
              onChange={() => setStatus(!status)}
              color="primary"
            />
            <span>
              Status:{" "}
              <span className={status ? "on" : "off"}>
                {status ? "Visible" : "Hidden"}
              </span>
            </span>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Description"
            variant="outlined"
            error={err === 4}
            value={desc}
            size="small"
            multiline
            rows={4}
            onChange={(e) => setDesc(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography className={classes.sectionTitle}>Profile image</Typography>
          <Box className={classes.uploadWrap}>
            <input
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleImageChange}
              id="team-image-upload"
              type="file"
            />
            <label htmlFor="team-image-upload" style={{ display: "block" }}>
              <Box
                className={`${classes.uploadBox} ${
                  empPic.raw ? classes.uploadBoxFilled : ""
                }`}
              >
                <Box className={classes.uploadIconWrap}>
                  {empPic.raw ? (
                    <InsertPhotoOutlinedIcon />
                  ) : (
                    <CloudUploadOutlinedIcon />
                  )}
                </Box>
                <Box className={classes.uploadInfo}>
                  {empPic.raw ? (
                    <>
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <CheckCircleOutlineIcon
                          style={{ fontSize: 16, color: "#10b981" }}
                        />
                        <strong>{empPic.raw.name}</strong>
                      </span>
                      <Typography className={classes.uploadHint}>
                        Click to choose a different file
                      </Typography>
                    </>
                  ) : (
                    <>
                      <span>
                        <strong>Upload profile image</strong>
                      </span>
                      <Typography className={classes.uploadHint}>
                        JPEG, PNG or WebP, up to 5 MB
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>
            </label>
            {empPic.preview && (
              <img
                src={empPic.preview}
                alt="preview"
                className={classes.uploadPreview}
                style={{ maxWidth: 200, maxHeight: 200 }}
              />
            )}
            {err === 7 && (
              <Typography style={{ color: "#dc2626", fontSize: "0.78rem" }}>
                Please select an image.
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      <Box className={classes.formFooter}>
        <Button
          className={classes.secondaryBtn}
          onClick={() => navigate("/dash/team")}
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          disabled={submitting}
          className={classes.primaryBtn}
          endIcon={!submitting && <ArrowForwardIcon />}
        >
          {submitting ? "Adding..." : "Add Member"}
        </Button>
      </Box>
    </div>
  );
};
